import { KeyboardArrowDown, KeyboardArrowUp, PhoneAndroid } from '@mui/icons-material'
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material'
import React, { useContext, useState } from 'react'
import { IconSx } from './CardPessoa'
import { WebSocketContext } from '../../../../Providers/WebSocket/WebSocketContext'
import { CondominiosContext } from '../../../../Providers/CondominiosContext/CondominiosContext'
import { UserContext } from '../../../../Providers/UserContext/UserContex'
import { showNotify, TIPOS_LICENCA_COND } from '../../../../Utils/Utils'

const ListClickToCall = ({ pessoa, ramalImovel, tooltipText = false, tooltipPosition = 'bottom', tipo_licenca_cond = false }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { activeCond } = useContext(CondominiosContext)
    const { user, check } = useContext(UserContext)
    const [telefone, setTelefone] = useState(false)
    const openTelefone = Boolean(telefone)

    const handleClick = (event) => {
        setTelefone(event.currentTarget)
    }
    const handleClose = () => {
        setTelefone(null)
    }

    const handleClickToCall = (telefone, nomeOrigem, app = 0) => {
        setTelefone(false)

        if (tipo_licenca_cond && (tipo_licenca_cond == TIPOS_LICENCA_COND.AG || tipo_licenca_cond == TIPOS_LICENCA_COND.AGPLUS)) {
            return showNotify('warning', 'O ClickToCall não está disponível para o tipo de licença contratada para esse condomínio. (AG ou AGPLUS)', { autoClose: 4000 })
        }

        addRoute('ligarUsuario', (msg) => {
            let dados = msg.data
            let obj = {
                origin: window.location.hostname,
                data: {
                    cmd: "obsligacao",
                    dados: {
                        status: false,
                        usuario: user.id,
                        nomeMorador: pessoa.nome,
                        nome: user.nome,
                        fone: telefone,
                        tipo: 1,
                        Apto: pessoa.unidade2,
                        Bloco: pessoa.unidade1,
                        NomeApto: pessoa.desc_tipo_imovel,
                        NomeBloco: pessoa.tipo_imovel,
                        ramal_operador_plus: check?.ramal
                    }
                }
            }
            if (dados.ligar != "OK") {
                showNotify('error', dados.message)
            } else {
                if (dados.ligar == "OK") {
                    obj.data.dados.status = true
                    global.trataIframe(obj)
                } else {
                    showNotify("warning", 'Erro ao ligar' + telefone)
                    global.trataIframe(obj)
                }
            }
        })
        sendWs('ligarUsuario', { filtros: { fone: telefone, conta: activeCond.id_central, codigo: pessoa.codigo, app, nomeOrigem, ramal_operador_plus: check?.ramal } })
    }

    const TooltipRender = ({ children, tooltipText, tooltipPosition }) => {
        return (
            <>
                { tooltipText
                    ? (
                        <Tooltip title={tooltipText} placement={tooltipPosition} arrow>
                            { children }
                        </Tooltip>
                    )
                    : children
                }
            </>
        )
    }

    return (

        <div>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >

                <TooltipRender tooltipText={tooltipText} tooltipPosition={tooltipPosition} arrow>
                    <PhoneAndroid sx={IconSx} />
                </TooltipRender>
                {openTelefone
                    ? (<KeyboardArrowUp sx={{ fontSize: '21px', alignSelf: 'center', color: 'black' }}/>)
                    : (<KeyboardArrowDown sx={{ fontSize: '21px', alignSelf: 'center', color: 'black' }}/>)
                }

            </IconButton>

            <Menu
                anchorEl={telefone}
                open={openTelefone}
                onClose={handleClose}
            >
                {pessoa.telefone && pessoa.telefone.length > 0
                    ? <MenuItem onClick={ () => handleClickToCall(pessoa.telefone) }>{pessoa.telefone}</MenuItem>
                    : ''
                }
                { pessoa.obsTelefones && pessoa.obsTelefones.length > 0
                    ? pessoa.obsTelefones.map((telefone) => {
                        return (<MenuItem onClick={ () => handleClickToCall(telefone) }>{telefone}</MenuItem>)
                    })
                    : ''
                }
                {pessoa.telefoneImovel && pessoa.telefoneImovel.length > 0
                    ? <MenuItem onClick={ () => handleClickToCall(pessoa.telefoneImovel) }>{pessoa.telefoneImovel}</MenuItem>
                    : ''
                }
                {pessoa.ramalApp && pessoa.ramalApp.length > 0
                    ? <MenuItem onClick={ () => handleClickToCall(pessoa.ramalApp, user.nome, 3) }>Ligar para APP</MenuItem>
                    : ''
                }
                {ramalImovel && ramalImovel.length > 0
                    ? <MenuItem onClick={ () => handleClickToCall(ramalImovel) }>Ligar para {ramalImovel}</MenuItem>
                    : ''
                }
                {
                    pessoa.telefone && pessoa.telefone.length <= 0 &&
                    pessoa.obsTelefones && pessoa.obsTelefones.length <= 0 &&
                    pessoa.telefoneImovel && pessoa.telefoneImovel.length <= 0 &&
                    pessoa.ramalApp && pessoa.ramalApp.length <= 0 &&
                    ramalImovel && ramalImovel.length <= 0
                    ? <MenuItem>nenhum</MenuItem>
                    : ''
                }
            </Menu>
        </div>
    )
}
export default ListClickToCall
